import { useLayoutEffect } from "react";
import { Intercom } from "@intercom/messenger-js-sdk";
import type { InitType } from "@intercom/messenger-js-sdk/dist/types";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "pages";

import { fetchIntercomData, INTERCOM_APP_ID } from "~utils";

// keep as `.css` not `.module.css`
import "./IntercomMessenger.css";

export function IntercomMessenger() {
  const { userInfo } = useAuth();

  const { data, error } = useQuery({
    queryKey: ["intercom-messenger-admin"],
    queryFn: async () => {
      const { data } = await fetchIntercomData();
      return data;
    },
  });

  useLayoutEffect(() => {
    const config: InitType = {
      /* data */
      app_id: INTERCOM_APP_ID,
      email: userInfo.email,
      name: userInfo.name,
      user_id: userInfo.id, // maps to external_id in Intercom
      /* settings */
      alignment: "right",
      hide_default_launcher: true, // do not show launcher icon
      horizontal_padding: 40,
      session_duration: 30 * 24 * 60 * 60 * 1000, // 30 day cookie expiration
      vertical_padding: 40,
    };

    // only include if `useQuery` is successful
    if (data) {
      config.user_type = data.userType;
      config.user_hash = data.hmacValue;
    }

    try {
      Intercom(config);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to initialize Intercom:", error);
    }

    // log error but allow Intercom to initialize
    if (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to fetch Swing data for Intercom:", error);
    }
  }, [userInfo.email, userInfo.id, userInfo.name, data, error]);

  return null;
}
